import * as React from "react";
import { Layout } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom'; 
import { RouteContent } from './routes';
import { SideMenu } from "./components/SideMenu";
import { AppContextProvider } from "./context/AppContext";
import { useEffect } from 'react';

const { Content } = Layout;

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hideSidebarOnPaths = ['/login'];
  const shouldShowSidebar = !hideSidebarOnPaths.includes(location.pathname);
  const accessToken = localStorage.getItem('ACCESS_TOKEN')

  useEffect(() => {
    if (location.pathname === '/' && !accessToken) {
      navigate('/login');
    }else if(location.pathname === '/' && accessToken){
      navigate('/transactions')
    }
  }, [accessToken, location, navigate]);

  return (
    <AppContextProvider>
      <Layout style={{ minHeight: '100vh', backgroundColor: '#FFF2F2'}} hasSider>
        {shouldShowSidebar && <SideMenu />}
        <Layout style={shouldShowSidebar && { marginLeft: 250 }} className={`site-layout ${shouldShowSidebar ? 'normal-layout' : ''}`}>
          <Content className={`${shouldShowSidebar ? 'content-layout px-20 py-10' : ''}`}>
            <RouteContent />
          </Content>
        </Layout>
      </Layout>
    </AppContextProvider>
  );
};

export default App;
